import { lineTotal } from "./quantity";

export interface ItemInterface {
	id?: number;
	item_code?: string;
	item?: string;
	price?: number;
	stock?: number;
	quantity?: number;
	category?: string;
	isFractional?: boolean;
	IsFractional?: boolean;
	minSellPrice?: number;
}

export class Item implements ItemInterface {
	id: number;
	item_code: string;
	item: string;
	price: number;
	stock: number;
	quantity: number;
	category: string;
	isFractional: boolean;
	minSellPrice: number;

	constructor(data: ItemInterface = {}) {
		this.id = data.id ?? 0;
		this.item_code = data.item_code ?? '';
		this.item = data.item ?? '';
		this.price = data.price ?? 0;
		this.stock = data.stock ?? 0;
		this.quantity = data.quantity ?? 1;
		this.category = data.category ?? "None";
		this.isFractional = data.isFractional === true || data.IsFractional === true;
		this.minSellPrice = Number(data.minSellPrice) > 0 ? Number(data.minSellPrice) : 0;
	}

	get total() {
		return lineTotal(this.quantity, this.price);
	}

	get uniqueId() {
		// return `${this.id}-${this.price}`; changed this to accomodate dynaming naming
		return `${this.item}-${this.price}`;
	};
}